// @flow
import * as csx from 'csstips';
import classify from '@src/utils/typestyle';

import type { StylesObjectType } from '@types/misc';

import {
  linkBlueText,
  lightGrayText,
  regularGrayText,
  borderGrayOutline,
  buttonBlueBackground
} from '@src/styles/general';

const questionMark = '/images/question_mark_with_circle.svg';

const styles = classify({
  container: {
    margin: '30px 0',
    position: 'relative'
  },
  table: {
    ...csx.horizontal,
    height: '37px',
    borderBottom: `3px solid ${buttonBlueBackground}`
  },
  box: {
    ...csx.horizontal,
    ...csx.center,
    ...csx.centerJustified,
    '-ms-flex-preferred-size': 0,
    flexBasis: 0,
    '-webkit-box-flex': 1,
    '-ms-flex-positive': 1,
    flexGrow: 1,
    borderTop: `1px solid ${borderGrayOutline}`,
    borderRight: `1px solid ${borderGrayOutline}`,
    color: lightGrayText,
    '&:first-child': {
      borderLeft: `1px solid ${borderGrayOutline}`
    }
  },
  content: {
    marginTop: '12px'
  },
  highlight: {
    color: 'white',
    borderRight: 'none',
    background: buttonBlueBackground,
    borderTop: `1px solid ${buttonBlueBackground}`,
    marginLeft: '-1px',
    '&:first-child': {
      borderLeft: 'none',
      marginLeft: 0
    }
  },
  header: {
    margin: '5px 0',
    fontWeight: '600',
    color: linkBlueText,
    textTransform: 'capitalize'
  },
  paragraph: {
    marginBottom: '8px',
    fontSize: '14px',
    lineHeight: '22px',
    color: regularGrayText
  },
  headerQuestionMark: {
    width: 14,
    cursor: 'pointer'
  }
});

type SpecType = {
  name?: string,
  title?: string,
  symbol: string,
  descriptions: Array<string>
};

type PropsType = {
  index: number,
  items: Array<SpecType>,
  spec: string,
  style?: StylesObjectType,
  children?: React.Element<any>,
  Popup: (N: React.Node) => React.Node
};

class DiamondSpecTable extends React.Component<PropsType> {
  calculateHighlight (i: number) {
    if (i === this.props.index) return styles.highlight;
    return '';
  }

  render () {
    const { Popup } = this.props;
    const boxWidth = {
      width: Math.floor(1 / this.props.items.length * 100) + '%'
    };

    return (
      <div className={styles.container} style={this.props.style}>
        <div className={styles.table}>
          {this.props.items.map((item, i) => {
            return (
              <div
                key={i}
                className={`${styles.box} ${this.calculateHighlight(i)}`}
                style={Object.assign(boxWidth)}>
                {item.symbol}
              </div>
            );
          })}
        </div>
        <div className={styles.content}>
          <Popup className={styles.header}>
            {this.props.items[this.props.index].title ||
              this.props.items[this.props.index].symbol}{' '}
            {this.props.spec}{' '}
            <img src={questionMark} className={styles.headerQuestionMark} />
          </Popup>{' '}
          <div>
            {this.props.items[this.props.index].descriptions.map((desc, i) => {
              return (
                <div className={styles.paragraph} key={i}>
                  {desc}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default DiamondSpecTable;
